import { takeEvery, fork, put, all } from "redux-saga/effects"

//Account Redux states
import { REGISTER_USER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed } from "./actions"

import ApiService from "../../../data/services/ApiService"

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user, history } }) {
    try {
        const response = yield ApiService.signup({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            password: user.password,
            countryCode: user.countryCode,
            phone: user.phone,
        })

        if (!response.data.success) {
            yield put(registerUserFailed(`signup failed`))
            return
        }

        yield put(registerUserSuccessful(response))
    } catch (error) {
        yield put(registerUserFailed(error))
    }
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, registerUser)
}

function* accountSaga() {
    yield all([fork(watchUserRegister)])
}

export default accountSaga
